import { render, staticRenderFns } from "./OidcSilentRenew.vue?vue&type=template&id=5a39d2ca&"
import script from "./OidcSilentRenew.vue?vue&type=script&lang=js&"
export * from "./OidcSilentRenew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports